import React, { FC, useContext, useEffect, useState } from 'react';
import { Events, eventType } from '../../scripts/dataSources/events';
import LoadingPage from '../common/LoadingPage';
import Toggle from '../common/toggle/Toggle';
import { DataContext } from '../context/dataLoader/DataLoader';
import EventList from './eventList/EventList';

import './EventViewerPage.scss';

let _hideLosers = false;

const EventViewerPage: FC = () => {

    const { events, eventsWithTeamStates, allGames, simModel, playerCollections, teamCollections } = useContext(DataContext)


    const [hideLosers, setHideLosers] = useState<boolean>(_hideLosers)

    useEffect(() => {
        _hideLosers = hideLosers
    }, [hideLosers])





    if (!events || !allGames || !simModel || !playerCollections || !teamCollections) {
        return <LoadingPage />
    }


    const gameEvents = events.filter(Events.isGameEvent);
    const electionEvents = events.filter(Events.isElectionEvent);

    const viewerData = {
        gameEvents,
        electionEvents,
        eventsWithTeamStates,
        gamesById: allGames.gamesById,
        simModel,
        allPlayers: playerCollections.allPlayers,
        allTeams: teamCollections.allTeams
    }

    const excludedList: eventType[] = [];
    if (hideLosers) {
        excludedList.push("cant-lose")
    }

    return <div className='Page EventViewer'>
        <div className="settings">
            <Toggle currentValue={hideLosers} setter={setHideLosers}>
                Hide cursed player team changes
            </Toggle>
        </div>
        <EventList data={viewerData} excludedEventTypes={excludedList} />
    </div>
}

export default EventViewerPage;